import { useEffect, useState, useContext } from 'react';
import { useAPI } from '../services/api';
import { Col, ListGroup, ListGroupItem, Row } from 'react-bootstrap';
import ToastContext from '../contexts/toast-context';
import User from '../components/users/User';
import AddUser from '../components/users/AddUser';
import Loading from '../components/Loading';

const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const api = useAPI();
  const { handleError } = useContext(ToastContext);

  useEffect(() => {
    const getUsers = async () => {
      try {
        let { data } = await api.get('/users');
        setUsers(data);
      } catch (e) {
        handleError(e);
      }
    };
    getUsers();
  }, [api, handleError]);
  return (
    <div style={{ maxWidth: 1000, padding: 16, margin: '0 auto', width: '100%' }}>
      <div className="d-flex justify-content-between align-items-center mt-2">
        <h1>Users</h1>
        <AddUser updateUsers={setUsers} />
      </div>
      {users.length ? (
        <ListGroup>
          <ListGroupItem className="d-md-flex justify-content-between align-items-center px-3 py-2 p-md-1">
            <Row className="flex-grow-1 fw-bold">
              <Col xs={12} md={3}>
                Username
              </Col>
              <Col xs={12} md={3}>
                Display Name
              </Col>
              <Col xs={12} md={3}>
                Role
              </Col>
            </Row>
          </ListGroupItem>
          {users.map((user) => (
            <User user={user} key={user.id} updateUsers={setUsers} />
          ))}
        </ListGroup>
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default UsersPage;
